// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"8ddd7e74","598":"09b9a061","703":"20781414","787":"73e98edb"}[chunkId] + ".chunk.js";
};